// Zentraler API-Helper. Verwendet REACT_APP_BACKEND_URL.
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const TOKEN_KEY = "tx_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const handle = async (res, opts = {}) => {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try { const j = await res.json(); detail = j.detail || detail; } catch { /* ignore parse */ }

    if (res.status === 401 && !opts.skipAuthRedirect) {
      clearToken();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
      throw new Error(detail || "Nicht angemeldet");
    }
    throw new Error(detail);
  }
  return res.json();
};

export const apiGet = (path) => fetch(`${API}${path}`).then((r) => handle(r, { skipAuthRedirect: true }));

export const apiAuthGet = (path) =>
  fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${getToken()}` } }).then(handle);

export const apiAuthSend = (method, path, body) =>
  fetch(`${API}${path}`, {
    method,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
    body: body ? JSON.stringify(body) : undefined,
  }).then(handle);

export const apiPost = (path, body) =>
  fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then((r) => handle(r, { skipAuthRedirect: true }));
